export default __webpack_public_path__ + "static/media/logo6.492813b6.png";